import React, { useState } from "react";
import styled from "styled-components";

import { TrafficBadges } from "../solution/solution_components.js";
import {  LineGraph, GraphTitle } from "./graph.js";

import { Wrapper, NavText, NavTitle } from "./nav_components.js";
import { StyledBox, Caption } from "../../cards/card_componets.js";

export default function TrafficFlow() {
  var bname = sessionStorage.getItem("bname");

  return (
    <Wrapper>
      <NavTitle> 내 주차장 주변 교통유입량</NavTitle>
      <NavText> 내 주차장 주변의 평균 교통 유입량을 시각화 한 그래프 입니다.</NavText>
      <StyledBox height="620" width="1200" padding="40">
        <GraphTitle fontSize="20">
        <TrafficBadges badgeText="A대로" bname={bname}></TrafficBadges>
        <TrafficBadges badgeText="B대로" bname={bname}></TrafficBadges>
        <TrafficBadges badgeText="C대로" bname={bname}></TrafficBadges>
        의 평균 교통 유입량
        </GraphTitle>
        <Caption marginTop="20"marginBottom="50">
          *선 그래프의 각 포인트에 마우스를 올려보세요
        </Caption>
        <LineGraph />
      </StyledBox>
    </Wrapper>
  );
}
